import { withOData } from "@odata/withOData";
import { BackgroundJobTableView } from "@pages/backgroundJob/BackgroundJobTableView";
import Page, { IProps } from "@pages/Page";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";

import { getDefinitions } from "./BackgroundJob.def";

class BackgroundJob extends Page<IProps> {
    static defaultProps = {
        getDef: getDefinitions,
        tableView: BackgroundJobTableView
    };
}

export default withRouter(withTranslation(getDefinitions.translationFiles)(withOData(BackgroundJob)));